<template>
    <div>
        <div class="top">
            <div class="top-header">
            </div>
            <div class="container" v-if="orderInfo">
                <div class="header">
                    <h3>{{orderInfo.companyName}}</h3>
                    <p>{{orderInfo.companyBatchName}}</p>
                </div>

                <div class="card employee-wrapper">
                    <div class="emp-top">
                        <span class="emp-name">{{orderInfo.name}}</span><span
                            class="emp-mobile">{{orderInfo.mobile|mask("phone")}}</span>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">证件号码</div>
                        <div class="cell-value">{{orderInfo.idcard|mask("idcard")}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">体检编号</div>
                        <div class="cell-value">{{orderInfo.examNo}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">套餐分组</div>
                        <div class="cell-value" @click="showGroupItems = true">{{orderInfo.groupName}}
                            <span style="float:right;color:#1496f1;">共{{groupItemsCount}}项
                                <van-icon name="arrow" /></span></div>
                    </div>
                </div>
                <div class="card add-item-card">
                    <p class="title">请选择加项</p>
                    <ul v-if="groupInfo">
                        <li class="item-wrapper" v-for="(combo,i) in groupInfo.combos">
                            <div class="combo-list">
                                <div class="combo-item">
                                    <van-checkbox v-model="combo.selected" @change="onComboCheck($event,combo)">
                                        {{combo.comboName}}
                                    </van-checkbox>
                                </div>
                                <div class="combo-point">需用点数:{{combo.consumePoints}}</div>
                            </div>
                            <div class="combo-extra">
                                <div class="combo-mean" v-if="combo.comboMeanning && combo.comboMeanning.length">
                                    {{combo.comboMeanning}}
                                </div>
                                <div class="combo-tag1"
                                    v-if="combo.comboImportantTips && combo.comboImportantTips.length">
                                    {{combo.comboImportantTips}}
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>

        <div class="fixed-footer page-footer">
            <div class="total-wrap" v-if="">
                <div>
                    <span>合计使用点数:</span><span class="num-tag">{{usedPoints}}</span>
                </div>
                <div>
                    <span>剩余可用点数:</span><span class="num-tag">{{avaliblePoints}}</span>
                </div>
            </div>
            <div class="btn-wrap">
                <div class="btn" @click="submitCombos()">选好了</div>
            </div>
        </div>

        <!-- 显示分组明细项目 -->
        <van-popup v-model="showGroupItems" round position="bottom">
            <div class="group-items-wrapper">
                <p class="group-items-header">套餐分组项目</p>
                <div v-for="group in groupItems">
                    <div class="group-title">{{group.title}}</div>
                    <ul class="item-list">
                        <li v-for="(item,i) in group.items" class="item-detail">
                            <p class="item-name">{{item.itemName}}</p>
                            <p class="item-mean">{{item.itemMeanning}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<style lang="less" scoped>
    .top {
        width: 100%;
        position: relative;
        z-index: 0;
        overflow: hidden;
        color: #ffffff;
    }

    .top::before {
        content: '';
        width: 120%;
        height: 160px;
        position: absolute;
        left: -10%; //椭圆左边隐藏10%，右边隐藏10%
        top: 0;
        border-radius: 0 0 50% 50%; //左上角，右上角，右下角，左下角
        background: #1496f1;
        z-index: -1;
    }

    .container {
        width: calc(100% - 20px);
        min-height: 80vh;
        top: 0;
        left: 0;
        padding: 10px;
        padding-bottom: 60px;

        .header {
            color: #ffffff;

            h3 {
                line-height: 36px;
                font-size: 20px;
                font-weight: 600;
            }

            p {
                font-size: 14px;
            }
        }

        .card {
            margin-top: 16px;
            background: #ffffff;
            border-radius: 8px;
            color: rgba(0, 0, 0, 0.75);
            padding: 16px;
        }

        .employee-wrapper {
            .emp-top {
                margin-bottom: 10px;

                .emp-name {
                    font-size: 18px;

                }

                .emp-mobile {
                    margin-left: 16px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.45)
                }
            }


            .info-cell {
                display: flex;
                padding: 10px 0;
                font-size: 14px;

                .cell-text {
                    width: 100px;
                    color: rgba(0, 0, 0, 0.45);
                }

                .cell-value {
                    flex: 1;
                }
            }
        }

        .add-item-card {
            .title {
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 8px;
            }

            .combo-list {
                display: flex;
                align-items: center;
                padding-top: 12px;

                .combo-item {
                    flex: 1;
                    line-height: 24px;
                    font-size: 14px;

                    /deep/.van-checkbox__icon .van-icon {
                        line-height: 1em;
                    }

                    //font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                }

                .combo-point {
                    font-size: 13px;

                }

                .van-button--small {
                    padding: 0 16px;
                }
            }

            .combo-extra {
                padding-left: 28px;

                .combo-mean {
                    padding: 4px 0;
                    font-size: 13px;
                    color: rgba(0, 0, 0, 0.5);
                }

                .combo-tag1 {
                    background: rgb(255, 232, 210);
                    color: rgb(201, 74, 1);
                    font-size: 13px;
                    padding: 4px;
                    border-radius: 4px;
                }

                .combo-tag2 {
                    background: rgb(255, 232, 210);
                    color: rgb(201, 74, 1);
                }
            }
        }


    }

    .time-range-wrapper {
        padding: 20px 12px;

        .timeRanges {
            // display: flex;
            // flex-wrap: nowrap;
            // justify-content: space-between;
            overflow-x: auto;
            padding: 12px 0;


            .time-item {
                flex: 1;
                font-size: 14px;
                padding: 8px 12px;
                border: 1px solid #fafafa;
                border-radius: 5px;
                // border: 1px solid #cccccc;
                background-color: #fafafa;
                margin: 16px 8px;
                text-align: center;

                p {
                    font-size: 12px;
                    margin-top: 6px;
                    font-weight: 400;
                }
            }

            .time-item--disabled {
                color: #b5b5b5;

                p {
                    color: #b5b5b5;
                }
            }

            .time-item--selected {
                border: 1px solid var(--color-main);
                color: #169bd5;
                background-color: #f2f8fa;

                p {
                    color: var(--color-main);
                }
            }
        }

        .timeRanges--empty {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 250px;
            text-align: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
        }

        .appoint-time {
            line-height: 32px;
            color: #169bd5;
            margin-bottom: 16px;
        }
    }

    .group-items-wrapper {
        height: 80vh;
        overflow: auto;
        padding: 0 16px;

        .group-items-header {
            text-align: center;
            padding-top: 12px;
        }

        .group-title {
            font-size: 16px;
            font-weight: 600;
            padding: 16px 0 10px 0;
        }

        .item-list {
            padding: 0 16px;

            .item-detail {
                padding: 8px 0;
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);

                .item-name {
                    font-size: 14px;
                    padding-bottom: 4px;
                }

                .item-mean {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.45);
                }
            }
        }
    }

    .page-footer {
        display: flex;

        .total-wrap {
            flex: 1;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
            // font-weight: 300;
            padding: 6px 12px;

            .num-tag {
                font-size: 16px;
                font-weight: 600;
                color: #ff6633;
                margin-left: 8px;
            }
        }

        .btn-wrap {
            .btn {
                width: 90px;
                height: 32px;
                border-radius: 16px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-weight: 600;
                background: #1496f1;
                color: #fff;
                // border: 1px solid var(--color-main);
                margin-top: 8px;
                margin-right: 8px;
            }
        }
    }
</style>

<script>
    import {
        getGroupDetails
    } from '@/api/company';
    import {
        async
    } from 'q';
    import moment from 'moment';
    export default {
        data() {
            return {
                selectedIndex: -1,
                orderInfo: {},
                groupInfo: {},
                usedPoints: 0,
                usedComboCount: 0, //已选择的加项数量
                showGroupItems: false,
                groupItems: [],
            }
        },
        computed: {
            orderDisable: function () {
                return this.selectedIndex < 0;
            },
            hospId: function () {
                return this.$route.query.hospid;
            },
            avaliblePoints: function () {
                if (!this.groupInfo || this.groupInfo.points == 0) {
                    return 0;
                } else {
                    return this.groupInfo.points - this.usedPoints;
                }
            },
            groupItemsCount: function () {
                if (this.orderInfo && this.orderInfo.groupItems && this.groupItems.length) {
                    return this.orderInfo.groupItems.length;
                } else {
                    return 0;
                }
            }
        },
        methods: {
            onComboCheck(checked, combo) {
                var num = 0;
                for (let index = 0; index < this.groupInfo.combos.length; index++) {
                    const item = this.groupInfo.combos[index];
                    if (item.comboId !== combo.comboId && item.selected)
                        num += item.consumePoints;
                }
                console.log(num);
                if (checked && num + combo.consumePoints > this.groupInfo.points) {
                    combo.selected = false;
                    this.usedPoints = num;
                    this.$toast("可用点数不足");
                } else {
                    combo.selected = checked;
                    if (checked) {
                        this.usedPoints = num + combo.consumePoints;
                    } else {
                        this.usedPoints = num;
                    }

                }
            },
            submitCombos() {
                if (this.avaliblePoints > 0) {
                    this.$Dialog.confirm({
                            message: '您还有未使用的加项点数，是否继续？',
                            "cancelButtonText": "重新选择",
                            "confirmButtonText": "继续提交",
                        })
                        .then(() => {
                            var addCombos = this.groupInfo.combos.filter(it => {
                                return it.selected;
                            })
                            if (addCombos && addCombos.length) {
                                this.orderInfo.addCombos = addCombos;
                            } else {
                                this.orderInfo.addCombos = null;
                            }
                            localStorage.setItem("companyAppointment", JSON.stringify(this.orderInfo));
                            this.$router.push("/company/orderDetail/")
                        })
                        .catch(() => {
                            // on cancel
                        });
                } else if (this.avaliblePoints == 0) {
                    var addCombos = this.groupInfo.combos.filter(it => {
                        return it.selected;
                    })
                    if (addCombos && addCombos.length) {
                        this.orderInfo.addCombos = addCombos;
                    } else {
                        this.orderInfo.addCombos = null;
                    }
                    localStorage.setItem("companyAppointment", JSON.stringify(this.orderInfo));
                    this.$router.push("/company/orderDetail/")
                }
            },
        },
        mounted() {
            let hospid = this.$route.query.hospid;
            var appt = JSON.parse(localStorage.getItem("companyAppointment"));
            if (appt == null) {
                this.$router.push('/');
                return;
            }
            this.orderInfo = appt;
            if (this.orderInfo.groupItems && this.orderInfo.groupItems.length > 0) {
                var items0 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 0
                });
                if (items0.length > 0) {
                    this.groupItems.push({
                        title: "一般检查",
                        items: items0
                    })
                }
                var items1 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 1
                });
                if (items1.length > 0) {
                    this.groupItems.push({
                        title: "影像及辅助检查",
                        items: items1
                    })
                }
                var items2 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 2
                });
                if (items2.length > 0) {
                    this.groupItems.push({
                        title: "检验项目",
                        items: items2
                    })
                }
                var items3 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 3
                });
                if (items3.length > 0) {
                    this.groupItems.push({
                        title: "其它项目",
                        items: items3
                    })
                }
            }
            getGroupDetails(appt.groupId).then(res => {
                if (res.data == null || res.data.points == 0) {
                    this.$router.replace({
                        path: "/company/orderDetail"
                    });
                    return;
                } else {
                    this.groupInfo = res.data;
                }

            })
        }
    }
</script>